var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#8A8D8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12 5.12 2.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13 12 5.88-9.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7h8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-2h-.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.34d8b5824a9832df392c086919bc0860.svg";
export { ForwardRef as ReactComponent };